define(function (require) {

    var ViewController = require('web-agent-framework/ViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    ViewController.plugin({
        supportTranslation: true,
        webAgentPrefixDictionary: "LEWebAgent.",
        startTag: '[??',
        endTag: '??]',


        translate: function (key) {
            var localKey = this.webAgentPrefixDictionary + key;
            var value = agentLEManager.translateLE(localKey);
            if (value === "[??" + localKey + "??]") {
                value = agentLEManager.translateLE(key);
            }
            return value;
        },

        isTranslated: function (key, translatedText) {
            //var translatorKey = this.webAgentPrefixDictionary + key;
            if (!translatedText) {
                translatedText = this.translate(key);
            }
            return !(
                (translatedText.indexOf(this.startTag) === 0) &&
                translatedText.indexOf(this.endTag) === (translatedText.length - this.endTag.length)
            );
        },

        translateObj: function (key, args) {
            var value = agentLEManager.translateLE({key: this.webAgentPrefixDictionary + key, args: args});
            return value;
        }
    });

    // todo - what to export?

});
